module.exports = __webpack_public_path__ + "img/ojfeature3.de1db170.jpg";